import { ReactNode } from 'react';
import { Box } from '@mantine/core';

type Props = {
  children: ReactNode;
};

export const Sidebar = ({ children }: Props) => {
  return (
    <Box
      sx={theme => ({
        display: 'flex',
        flexDirection: 'column',
      })}
    >
      {children}
    </Box>
  );
};
